/**
 * 校验数据
 */

class Checkout {
  /**
     * 校验身份证号
     * @param {string} value 身份证号
     * @returns
     */
  checkCard(value) {
    if (
      !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/g.test(
        value.trim()
      )
    ) {
      return true
    } else {
      return false
    }
  }

  /**
     * 校验邮箱地址
     * @param {string} value 邮箱地址
     * @returns
     */
  checkEmail(value) {
    if (
      !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/g.test(
        value.trim()
      )
    ) {
      return true
    } else {
      return false
    }
  }

  /**
     * 校验手机号码
     * @param {string} value 手机号码
     * @returns
     */
  checkMobile(value) {
    if (
      !/^(13[0-9]|15[012356789]|16[012356789]|19[012356789]|17[0135678]|18[0-9]|14[579])[0-9]{8}$/g.test(
        value.trim()
      )
    ) {
      return true
    } else {
      return false
    }
  }
}

export { Checkout }

